import script from "./Contatore.vue?vue&type=script&setup=true&lang=js"
export * from "./Contatore.vue?vue&type=script&setup=true&lang=js"

import "./Contatore.vue?vue&type=style&index=0&id=0ebc85fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ebc85fa"]])

export default __exports__